import CreateSetupBackend from "../config/config.js";

let SetupBackend = null;

/**
 * MED — Mecanismo Especial de Devolução.
 *
 * ── O que é ──
 *
 * O processo do Banco Central para pedir de volta um PIX recebido de forma indevida (fraude
 * ou falha operacional). Quem pagou abre o caso; quem recebeu tem PRAZO para analisar e
 * devolver.
 *
 * ── Por que a conta não vai no pedido ──
 *
 * A API deriva a conta do e-mail autenticado. Um caso de MED carrega documento, valor e
 * dados bancários das DUAS partes: deixar o cliente informar a conta permitiria a ele ler o
 * caso de outro.
 */

function list(filters = {}) {
  SetupBackend = CreateSetupBackend();
  const email = sessionStorage.getItem("emailUser");

  const params = new URLSearchParams({ email });

  /*
    `onlyPending` é o filtro que importa no dia a dia: caso aberto tem prazo, e é o único que
    exige ação. A listagem completa serve para histórico.
  */
  if (filters.onlyPending !== undefined) {
    params.set("onlyPending", filters.onlyPending ? "true" : "false");
  }
  if (filters.role) params.set("role", filters.role);
  if (filters.from) params.set("from", filters.from);
  if (filters.to) params.set("to", filters.to);
  if (filters.page) params.set("page", String(filters.page));
  if (filters.limit) params.set("limit", String(filters.limit));

  (filters.objectTypes || []).forEach((tipo) => params.append("objectTypes", tipo));
  (filters.statuses || []).forEach((status) => params.append("statuses", status));

  return SetupBackend.get(`/v1/baas/med?${params.toString()}`);
}

function show(id) {
  SetupBackend = CreateSetupBackend();
  const email = sessionStorage.getItem("emailUser");

  return SetupBackend.get(
    `/v1/baas/med/${encodeURIComponent(id)}?email=${encodeURIComponent(email)}`,
  );
}

/**
 * Abre um caso contra uma transação.
 *
 * O `endToEndId` é o que dá objeto ao caso — sem ele não há pagamento a contestar. O valor é
 * opcional: ausente significa a transação inteira, que é o caso mais comum.
 */
function open(data) {
  SetupBackend = CreateSetupBackend();
  const email = sessionStorage.getItem("emailUser");

  return SetupBackend.post(`/v1/baas/med?email=${encodeURIComponent(email)}`, {
    endToEndId: data.endToEndId,
    objectType: data.objectType,
    reason: data.reason,
    details: data.details,
    // Enviado só quando há valor: string vazia seria lida como zero, e um caso de valor zero
    // não pede nada — com o prazo correndo igual.
    ...(data.amount ? { amount: data.amount } : {}),
  });
}

function cancel(id, reason) {
  SetupBackend = CreateSetupBackend();
  const email = sessionStorage.getItem("emailUser");

  return SetupBackend.post(
    `/v1/baas/med/${encodeURIComponent(id)}/cancel?email=${encodeURIComponent(email)}`,
    { reason },
  );
}

const backendServices = { list, show, open, cancel };

export default backendServices;
